export default "/images/vehicles.jpg?214c6f643816717526bc09408b805dc2";